import * as yup from 'yup';

type Registration = {
    userName?:string,
    name:string,
    email:string,
    password:string,
    confirmPassword:string
}

export const validateRegistration = async (formValues:Registration)=>{
    try{

        const schema = yup.object().shape({
            name:yup.string().required().min(5),
            email:yup.string().email().required(),
            password:yup.string().min(8).required(),
            confirmPassword:yup.string().required().oneOf([yup.ref('password')], 'confirmPassword does not match.')
        })
        const validation = await schema.validate(formValues)
        return {isError:false}
    }catch(err:  any){
        return {isError:true,errors:err.errors}
    }
    
}

export const validateLogin = async (formValues:{email:string,password:string})=>{
    try{

        const schema = yup.object().shape({
            email:yup.string().email(),
            password:yup.string().min(8)
        })
        const validation = await schema.validate(formValues)
        return {isError:false}
    }catch(err:  any){
        return {isError:true,errors:err.errors}
    }
    
}

export const validateSetNewPassword = async (formValues:{email:string,password:string,confirmPassword:string})=>{
    try{
        const schema = yup.object().shape({
            email:yup.string().email().required(),
            password:yup.string().min(8).required(),
            confirmPassword:yup.string().required().oneOf([yup.ref('password')], 'confirmPassword does not match.')
        })
        const validation = await schema.validate(formValues)
        
        return {isError:false}
    }catch(err:  any){
        return {isError:true,errors:err.errors}
    }
}

export const validateEmail = async (formValues:{email:string})=>{
    try{
        const schema = yup.object().shape({
            email:yup.string().email().required(),
        })
        const validation = await schema.validate(formValues)
        return {isError:false}
    }catch(err:  any){
        return {isError:true,errors:err.errors}
    }
}

export const validateCreatePageForm = async (formValues:{pageName:string,template:string})=>{
    try{
        const schema = yup.object().shape({
            pageName:yup.string().required().matches(/^[a-zA-Z0-9]+$/, 'Page Name can only include letters and numbers. No spaces.'),
            template:yup.string().required(),
        })
        const validation = await schema.validate(formValues)
        return {isError:false}
    }catch(err:  any){
        return {isError:true,errors:err.errors}
    }
}